<template>
  <div
    class="shimmer"
    :style="{
      height: height,
      width: width,
      margin: margin,
      display: 'block',
    }"
  ></div>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '30px',
    },
    width: {
      type: String,
      default: '350px',
    },
    margin: {
      type: String,
      default: '0px 0px 0px 0px',
    },
  },
}
</script>

<style src="../../assets/css/Elements/ShimmerView.css" scoped></style>
